// Duitse teksten van de to-do's op het bord (zie todo.nl.ts).
export const todoDe = {
    title: 'To-do',
    from: 'von {name}',
    all: 'Alle To-dos ({count})',
    sheetTitle: 'To-dos von {name}',
    due: 'bis spätestens {date}',
    empty: 'Nichts mehr zu tun',
    done: 'Erledigt',
    everyone: 'Alle',
    filterOpen: 'Offen',
    filterDone: 'Erledigt',
    filterAll: 'Alle',
    doneSection: 'Erledigt ({n})',
    doneBy: '{name} · {when}',
    forWho: 'für {name}',
    created: 'angelegt am {date}',
    important: 'Wichtig',
    add: 'To-do hinzufügen',
    noDescription: 'Keine Beschreibung',
    emptyDone: 'Diese Woche noch nichts erledigt',
    assign: 'Zuweisen an…',
    assignTitle: 'Zuweisen an',
    assignSave: 'Zuweisen',
    assigned: 'Zugewiesen',
    assignFailed: 'Zuweisen hat nicht geklappt',
};
//# sourceMappingURL=todo.de.js.map